module.exports = __webpack_public_path__ + "img/P150T_weapon_91.e16491d5.png";